export default "__VITE_ASSET__BRI_fNCq__"